import { getConfig } from '../config/configuration';
import type { HpDispatchFunction } from './actionTypes';
import { fetchResolver } from './fetchResolver';
import { State } from 'reducers/initialState';

interface ClaimsPortalRedirectProps {
  emailAddress?: string;
  postcode?: string;
}

interface RedirectProps {
  url: string;
  openInNewTab: boolean;
}

const redirectToUrl = ({ url, openInNewTab }: RedirectProps): void => {
  setTimeout(() => {
    const link = document.createElement('a');
    link.href = url;
    if (openInNewTab) {
      link.target = '_blank';
    }

    document.body.appendChild(link);
    link.click();
    setTimeout(() => {
      document.body.removeChild(link);
    }, 100);
  }, 1000);
};

const redirectCustomerToClaims = (dispatch: HpDispatchFunction<undefined>) => {
  const { websiteEndpoint, claimsPortalUrl } = getConfig();
  const url = `${websiteEndpoint}/api/make-claim`;
  const urlParameter = '?customerDetailsKey=';
  const redirectUrl = `${claimsPortalUrl}${urlParameter}`;

  return fetchResolver<any>({
    options: { url, data: {}, method: 'POST', description: `Redirect to claims` },
    dispatch,
    successAction: (response) => {
      const { key } = response;
      const url = `${redirectUrl}${key}`;
      redirectToUrl({ openInNewTab: false, url });
      dispatch({ type: 'CLAIMS_REDIRECT_SUCCESS' });
    },
    failedAction: () => {
      dispatch({ type: 'CLAIMS_REDIRECT_ERROR' });
    }
  });
};

const redirectAgentToClaims = (dispatch: HpDispatchFunction<undefined>, payload: ClaimsPortalRedirectProps): void => {
  const { claimsPortalUrl } = getConfig();
  const { emailAddress, postcode } = payload;
  const emailParameter = '?emailAddress=';
  const postcodeParameter = '&postcode=';
  const originParameter = '&origin=customerportal';
  const redirectUrl = claimsPortalUrl + emailParameter + emailAddress + postcodeParameter + postcode + originParameter;

  redirectToUrl({ openInNewTab: false, url: redirectUrl });
  dispatch({ type: 'CLAIMS_REDIRECT_SUCCESS' });
};

export function redirectToClaimsPortalAction(payload: ClaimsPortalRedirectProps) {
  return (dispatch: HpDispatchFunction<undefined>, getState: () => State): Promise<void> | void => {
    const state = getState();
    const { authentication } = state;
    const { isAgent } = authentication;
    dispatch({ type: 'CLAIMS_REDIRECT_LOADING' });

    if (isAgent) {
      return redirectAgentToClaims(dispatch, payload);
    }

    return redirectCustomerToClaims(dispatch);
  };
}
